import { render, staticRenderFns } from "./show_items.vue?vue&type=template&id=9d62d1ac&scoped=true&"
import script from "./show_items.vue?vue&type=script&lang=js&"
export * from "./show_items.vue?vue&type=script&lang=js&"
import style0 from "./show_items.vue?vue&type=style&index=0&id=9d62d1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d62d1ac",
  null
  
)

export default component.exports